import React from 'react';
import { View, Text, Pressable } from 'react-native';

import { Button } from 'app/src/elements/buttons';

const UnmarkNoSale = props => {
  const { saleAsset, updateSaleAsset, setShowModal } = props;

  const markNoSale = () => {
    updateSaleAsset({
      variables: {
        id: saleAsset.id,
        status: 'Listed',
      }
    });

    setShowModal(false);
  };

  return (
    <View>
      <Text>Do you want to remove No Sale on {saleAsset.lotNumber}?</Text>
      <Button
        label="YES, remove No Sale status"
        onPress={markNoSale}
        wide
      />
      <Button
        label="Cancel"
        onPress={() => setShowModal(false)}
        wide
      />
    </View>
  );
};

export default UnmarkNoSale;
